import * as Api from './api';
import * as Types from './types';
import { entitlementsApi } from 'modules/entitlements';

export function isAccessContextReady(
  state: Pick<Types.IContext.State, 'isFetched' | 'accessFetched'>,
): boolean {
  return state.isFetched && state.accessFetched;
}

/** Call AFTER persisting the active org id — the interceptor reads it from localStorage. Failures don't clobber. */
export async function loadAccessContext(methods: Types.IContext.Value['methods']): Promise<void> {
  const [permsRes, entsRes] = await Promise.allSettled([Api.MyPermissions(), entitlementsApi.GetEntitlements()]);

  if (permsRes.status === 'fulfilled') {
    methods.setPermissions(permsRes.value.data.permissions || []);
  }
  if (entsRes.status === 'fulfilled') {
    methods.setEntitlements(entsRes.value.data || null);
  }

  // Mark the access context as settled even if a request failed, so one-shot
  // consumers (the default-landing redirect) stop waiting and fall back to their
  // least-privileged default rather than hanging on a loading screen.
  methods.setAccessFetched(true);
}
